import ViewModeSwitcher from '../property/grid-view-switcher';
import Discardable from '../property/discard';
import initPageContentLinkEvents from  '../property/page-content';
import PropertyFilterPopup from '../property/filter-popup';
import InlinePropertySearchForm from '../property/inline-form';
import initPropertySliders from '../property/sliders';
import initTagScrollers from '../property/tag-scroller';
import onSaveSearchProvideName from '../property/save-search-provide-name';
import GlobalContext from '../bootstrap';
import initTypeaheads from '../typeahead';
import initPagination from '../pagination';
import onPopupOpenLocation from '../events/popup-open-location';
import { onSaveChangeHandleViewMode } from '../property/save-events';

class PropertyPage extends GlobalContext {
    constructor() {
        super();
        this._registerEvents();
        this._initialiseComponents();
    }

    _registerEvents(): void {
        window.addEventListener( 'twc-save:save:property-search:provide-name', onSaveSearchProvideName );

        window.addEventListener( 'twc:saved-change', onSaveChangeHandleViewMode );

        window.addEventListener( 'twc:popup:open-location', onPopupOpenLocation );
    }

    _initialiseComponents(): void {
        const inlineForm: HTMLFormElement | null = document.querySelector( '#property-search-form-base' );

        if ( inlineForm ) {
            new InlinePropertySearchForm( inlineForm );
        }

        const filterPopup = document.querySelector<HTMLElement>( '#search-filter-popup' );

        if ( filterPopup && inlineForm ) {
            new PropertyFilterPopup( filterPopup, inlineForm );
        }

        new ViewModeSwitcher();

        new Discardable();

        initTypeaheads();

        initTagScrollers();

        initPageContentLinkEvents();

        initPropertySliders();

        if ( document.body.classList.contains( 'twc__pagination' ) ) {
            initPagination( document.body );
        }
    }
}

if ( !window.propertyPage ) {
    window.propertyPage = new PropertyPage();
}
